import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import {
  getInitials,
  isSolrInstance,
  runningNodeExists,
} from '../../../utils/utils';
import Image from '../../elements/image/Image';
import Status from '../../elements/status/Status';
import Text from '../../elements/text/Text';
import EntityChip from '../chips/EntityChip';
import SecondaryChip from '../chips/SecondaryChip';

const Overview = ({ data, button }) => {
  const isProject = !data?.clusterType;

  return (
    <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 3 }}>
      <Image src={data?.icon} alt="project avatar" shape="rounded" size="large">
        {getInitials(data.name)}
      </Image>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Text variant="h3">{data.name}</Text>
          {!isProject && (
            <Status
              instanceState={data?.status}
              solrRunning={
                isSolrInstance(data.clusterType)
                  ? runningNodeExists(data.instances)
                  : true
              }
            />
          )}
        </Box>
        <Text body color="textSecondary">
          {data.description}
        </Text>
        <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
          <EntityChip entity={data} />
          <SecondaryChip instance={data} />
        </Box>
      </Box>
      <Box sx={{ alignSelf: 'center' }}>{button}</Box>
    </Box>
  );
};

Overview.propTypes = {
  data: PropTypes.object.isRequired,
  button: PropTypes.node,
};
export default Overview;
